'use strict';
const angular = require('angular');

export class eformResultModalComponent {
  /*@ngInject*/
  constructor(EFormsService, Auth, $state, dialogs, $filter, $stateParams, $uibModal, EFormResultsService, $scope) {
    this.EFormsService = EFormsService;
    this.EFormResultsService = EFormResultsService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$scope = $scope;

    this.model = {};

    this.eFormResult = {
      data: {}
    };

    this.isLoggedIn = Auth.isLoggedInSync();
    this.user = Auth.getCurrentUserSync();
  }

  $onInit() {
    this.config = this.resolve.config;

    if (this.config.eFormId && this.config.eFormResultId) {
      this.EFormsService.get({id: this.config.eFormId}, form => {
        this.schema = form.formSchema;
        this.form = ["*"];
        this.title = form.name;
        this.description = form.description;
        this.signatureRequired = form.signatureRequired;

        this.imgFields = form.fields.filter(field => field.type == 'image');
        this.imgFields.forEach(field => {
          let key = field.key;
          let ppty = this.schema.properties[key];
          ppty.type = 'string';
          delete ppty.format;
          ppty["x-schema-form"].type = 'help';
          ppty["x-schema-form"].helpvalue = "";
        });

        this.EFormResultsService.get({id: this.config.eFormResultId}, eformResult => {
          this.model = eformResult;

          if (this.imgFields.length) {
            this.imgFields.forEach(field => {
              let key = field.key;
              let label = "<label class='control-label'>"+this.schema.properties[key].title+"</label><br/>";
              let value = "-";

              if (this.model.data[key]) {
                let imgPath = "/api/storage/"+this.model.data[key];
                value = "<a target='_blank' href='"+imgPath+"'><img src='"+imgPath+"/thumb' /></a><br/><span style='font-weight:normal;font-size:x-small'>(Preview - Click to enlarge)</span>";
              }

              this.schema.properties[key]["x-schema-form"].helpvalue = label + value;
            });

            this.$scope.$broadcast('schemaFormRedraw');
          }
        });
      }, _ => {
        console.log("Could not load e-form schema from server");
        this.formNotFound = true;
      });
    }
  }


  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.eFormResultModal', [])
  .component('eFormResultModal', {
    template: require('./eform-result-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: eformResultModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/eform-result-modal/eform-result-modal.component.js